var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    typeof _vm.getActiveUserData.user !== 'undefined' &&
      Object.keys(_vm.getActiveUserData.user).length
  )?_c('div',{staticClass:"row"},[(
      _vm.getActiveUserData.userRoles == 'admin' ||
        _vm.getActiveUserData.userRoles == 'salesmanager' ||
        _vm.getActiveUserData.userRoles == 'salesteamlead' ||
        _vm.getActiveUserData.userRoles == 'salesperson' ||
        _vm.getActiveUserData.userRoles == 'devops'
    )?_c('admin-header-header-vue'):(
      _vm.getActiveUserData.userRoles == 'marketingmanager' ||
        _vm.getActiveUserData.userRoles == 'marketingperson'
    )?_c('marketing-header-header-vue'):_c('default-header-vue')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }